<template>
  <div id="app">
    <div class="time-controls">
      <div class="quick-nav-item" @click="toogleGanttFilter">
        <i class="material-icons-outlined">filter_list</i>
      </div>
      <div class="quick-nav-item" @click="toogleFreeOrders">
        <i class="material-icons-outlined">assignment_late</i>
      </div>
      <Selector v-model="ganttType" :options="['dia', '3 dias', 'semana']"></Selector>
      <div class="spacer" />
      <div class="quick-nav-item" @click="$store.commit('resetTime')">hoje</div>
      <TimeControl
        v-if="ganttType !== 'semana'"
        :leftClick="() => $store.commit('advanceTime', {tipo: 'days', quantidade: -1})"
        :rigthClick="() => $store.commit('advanceTime', {tipo: 'days', quantidade: 1})"
      >dia</TimeControl>
      <TimeControl
        :leftClick="() => $store.commit('advanceTime', {tipo: 'weeks', quantidade: -1})"
        :rigthClick="() => $store.commit('advanceTime', {tipo: 'weeks', quantidade: 1})"
      >semana</TimeControl>
      <TimeControl
        :leftClick="() => $store.commit('advanceTime', {tipo: 'months', quantidade: -1})"
        :rigthClick="() => $store.commit('advanceTime', {tipo: 'months', quantidade: 1})"
      >mês</TimeControl>
    </div>
    <div class="gantt-container">
      <GanttFilters :open="filters.isOpen" />
      <FreeOrders :open="freeOrders.isOpen" />
      <div class="gantt-container__chart">
        <Gantt :key="key" :range="ganttType" />
      </div>
    </div>
    <RightSheet></RightSheet>
  </div>
</template>

<script>
import Gantt from "./components/Gantt";
import TimeControl from "./components/TimeControl";
import Selector from "./components/Selector";
import FreeOrders from "./components/FreeOrders";
import GanttFilters from "./components/GanttFilters";
import RightSheet from "./components/RightSheet";

export default {
  name: "App",
  components: {
    Gantt,
    TimeControl,
    Selector,
    FreeOrders,
    GanttFilters,
    RightSheet
  },
  data: () => ({
    buttons: ["todos", "produzindo", "setup", "ociosa", "parada"],
    model: "",
    ganttType: "dia",
    key: 0,
    filters: {
      isOpen: false
    },
    freeOrders: {
      isOpen: false
    }
  }),
  created() {
    this.$store.subscribe(mutation => {
      if (mutation.type === "removeSequencedOrder") {
        this.key += 1;
      } else if (mutation.type === "removeFreeOrder") {
        this.key += 1;
      } else if (mutation.type === "joinOrders") {
        this.key += 1;
      } else if (mutation.type === "divideOrder") {
        this.key += 1;
      }
    });
  },
  methods: {
    toogleFreeOrders() {
      if (this.filters.isOpen) {
        this.filters.isOpen = false;
        setTimeout(
          () => (this.freeOrders.isOpen = !this.freeOrders.isOpen),
          400
        );
      } else {
        this.freeOrders.isOpen = !this.freeOrders.isOpen;
      }
    },
    toogleGanttFilter() {
      if (this.freeOrders.isOpen) {
        this.freeOrders.isOpen = false;
        setTimeout(() => (this.filters.isOpen = !this.filters.isOpen), 400);
      } else {
        this.filters.isOpen = !this.filters.isOpen;
      }
    }
  }
};
</script>

<style scoped>
.heading {
  margin: 0;
  font-size: 3rem;
}

.gantt-container {
  position: relative;
}

.gantt-container__chart {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.time-controls {
  display: flex;
  width: 100%;
  margin: 3rem 0 0.4rem;
}

.spacer {
  margin-left: auto;
}

.quick-nav-item {
  background: #f9fafb;
  height: 2rem;
  border-radius: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  margin-right: 0.6rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 0 1.2rem;
  cursor: pointer;
  transition: background-color 0.3s;
}
.quick-nav-item:hover {
  background: var(--color-grey);
}
</style>
